module.exports = __webpack_public_path__ + "img/3-Zona de influencia PELT.71e3b443.png";